import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export const useModalHashChange = (hashName: string) => {
  const history = useHistory();
  const modalHashChange = useCallback(() => {
    history.push(history.location.pathname + `#${hashName.trim()}`);
    return () => {
      history.push(
        history.location.pathname.replace(`#${hashName.trim()}`, '')
      );
      return void 0;
    };
  }, [history, hashName]);
  return { modalHashChange };
};
